var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecentEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xF0\\x9F\\x93\\x8D timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\xE2\\x86\\xB3Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7V3h1a9 9 0 1 1-9 9c0-2.95 1.42-5.55 3.61-7.19v-.02l6.8 6.8L12 13 6.58 7.58A6.917 6.917 0 0 0 5 12c0 3.87 3.13 7 7 7s7-3.13 7-7c0-3.53-2.61-6.43-6-6.92V7h-2Zm1 11c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm6-6c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1ZM7 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecentEvents);
export default __webpack_public_path__ + "static/media/icon_recent_events.42955e7955c1ed1f4a369e6adfc0d853.svg";
export { ForwardRef as ReactComponent };